import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import DeleteModal from "../../components/DeleteModal";
import DebtModal from "../../components/DebtModal";
import {
  faCartShopping,
  faTrashAlt,
  faBasketShopping,
  faSearch,
  faEye,
  faEllipsisH,
} from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import Section from "../../components/Section";
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";

const PurchaseList = ({ handleLogout }) => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const distributorToken = localStorage.getItem('distributor');
  const [message, setMessage] = useState("");
  const [debtModal, setDebtModal] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      const isDropdownItem = event.target.closest(".dm-class");

      if (!isClickInsideDropdown && !isDropdownItem) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permission);
  };

  const fetchAllData = async (page = 1) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/orders?page=${page}`);
      if (Array.isArray(response.data.results)) {
        setData(response.data.results);
        setTotalItems(response.data.total);
      } else {
        setData([response.data.results]);
        setTotalItems(1);
      }
    } catch (error) {
      setIsErrorVisible(true);
      if (error.response && error.response.status === 401) {
        setIsInfoVisible(true);
      }
    } finally {
      setIsSuccessVisible(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData(currentPage);
  }, [currentPage]);

  const handleRefresh = () => {
    fetchAllData(currentPage);
  };

  const handleSearch = useCallback(
    async (page = 1) => {
      try {
        // Construir la URL con los query params
        const params = new URLSearchParams();
        if (search) params.append("search", search);

        const response = await apiClient.get(
          `/orders?${params.toString()}&page=${page}`
        );

        if (Array.isArray(response.data.results)) {
          setData(response.data.results); // Si es un array, lo dejamos tal cual
        } else {
          setData([response.data.results]); // Si es un objeto, lo encapsulamos en un array
        }
        setTotalItems(response.data.total);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      }
    },
    [search]
  );
  const handleFresh = async (code) => {
    handleSearch(1);
  };

  const handleVerifyDebt = async (item) => {
    try {
      const response = await apiClient.get(`/distributors/${distributorToken}/debt`);
      setMessage(response.data.blockReason)
      setDebtModal(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const balance = error.response.data.availableBalance;
        navigate(`/PurchaseSummary/${item.id}`, { state: { balance: balance } });

      }
      setLoading(false)
      if (error.response.data.error === "Unauthorized") {
        setIsInfoVisible(true);
      }
    }
  };
  const handleCloseDebModal = () => {
    setDebtModal(false);
  };

  const handleDeleteModal = (item) => {
    setSelectedDeleteItem(item);
    setDeleteItem(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteItem(false);
    setSelectedDeleteItem(null);
    handleRefresh();
  };

  const columns = [
    { title: "Id", key: "code" },
    { title: "Fecha de la Orden", key: "socialReason" },
    { title: "Fecha de Pago", key: "cif" },
    { title: "Canal", key: "chanel" },
    { title: "Usuario", key: "username" },
    { title: "Total", key: "created" },
    { title: "Estado", key: "estado" },
    { title: "Acciones", key: "acciones" },
  ];

  const renderRow = (item, index) => (
    <>
      <td>{item.id}</td>
      <td>{new Date(item.orderDate).toLocaleString()}</td>
      <td>
        {item.status === "Completed" ? (
          <div>{new Date(item.paymentDate).toLocaleString()}</div>
        ) : (
          <div className="align-center">-</div>
        )}
      </td>
      <td>{item.distributorName}</td>
      <td>{item.userName}</td>
      <td>{item.total}</td>
      {/*<td>{item.status}</td>*/}
      {item.status === "Completed" ? (
        <td style={{ color: "green" }}>Completo</td>
      ) : (
        <td style={{ color: "#d64724" }}>Pendiente</td>
      )}
      <td>
        {item.status === "Cart" ? (
          <div className="button-container">
            <div className="desktop-buttons">
              <Tooltip id="edit-tooltip" className="custom-tooltip" />
              {hasPermission("ORDER_VIEW") && (
                <button
                  data-tooltip-id="edit-tooltip"
                  className="icon-button edit-button"
                  data-tooltip-content="Ver"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/PurchaseView/${item.id}`);
                  }}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              )}
              <Tooltip id="contract-tooltip" className="custom-tooltip" />
              {hasPermission("ORDER_PURCHASE") && (
                <button
                  className="icon-button company-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleVerifyDebt(item)
                  }}
                  data-tooltip-id="contract-tooltip"
                  data-tooltip-content="Comprar"
                >
                  <FontAwesomeIcon icon={faCartShopping} />
                </button>
              )}
              <Tooltip id="delete-tooltip" className="custom-tooltip" />
              {hasPermission("ORDER_DELETE") && (
                <button
                  data-tooltip-id="delete-tooltip"
                  data-tooltip-content="Eliminar"
                  className="icon-button delete-button"
                  onClick={() => handleDeleteModal(item)}
                //onClick={() => handleDelete(item.id)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
            </div>

            <div className="mobile-dropdown">
              <div className="dropdown-container-contract">
                <button
                  className="icon-button dropdown-button-contract"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdown(openDropdown === item.id ? null : item.id);
                  }}
                >
                  <FontAwesomeIcon icon={faEllipsisH} />
                </button>
                {openDropdown === item.id && (
                  <div className="dropdown-menu-contract dm-class">
                    {hasPermission("ORDER_VIEW") && (
                      <button
                        className="dropdown-item-contract"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/PurchaseView/${item.id}`);
                        }}
                      >
                        Ver
                      </button>
                    )}
                    {hasPermission("ORDER_PURCHASE") && (
                      <button
                        className="dropdown-item-contract"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/PurchaseSummary/${item.id}`);
                        }}
                      >
                        Comprar
                      </button>
                    )}
                    {hasPermission("ORDER_DELETE") && (
                      <button
                        className="dropdown-item-contract"
                        onClick={() => {
                          handleDeleteModal(item);
                          setOpenDropdown(false);
                        }}>
                        Eliminar
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="button-container">
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("ORDER_VIEW") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Ver"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/PurchaseView/${item.id}`);
                }}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            )}
          </div>
        )}
      </td>
    </>
  );

  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Ordenes" />
      <div className="home-content">
        <Section>
          <div className="filter-form">
            <div className="basic-info-form-group">
              <input
                type="text"
                id="customer"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Orden"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleFresh();
                  }
                }}
              />
            </div>
            <button className="basic-custom-button" onClick={handleFresh}>
              <FontAwesomeIcon
                icon={faSearch}
                className="basic-shortcut-icon"
              />
              Buscar
            </button>
          </div>
        </Section>

        <Table
          title="Lista de Ordenes"
          rows={data}
          columns={columns}
          icon={faBasketShopping}
          renderRow={renderRow}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onRefresh={handleRefresh}
          loading={loading}
          flagPagination={true}
        />
        <SuccessNotification
          message={"Se ha cargado correctamente"}
          isVisible={isSuccessVisible}
          onClose={() => setIsSuccessVisible(false)}
        />
        <ErrorNotification
          message="Ups! Ocurrio un Problema"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
        <LoginNotification
          message="Vuele a iniciar sesión"
          isVisible={isInfoVisible}
          onClose={() => setIsInfoVisible(false)}
          onLogout={handleLogout}
        />
        {selectedDeleteItem && (
          <DeleteModal
            isVisible={deleteItem}
            onClose={handleCloseDeleteModal}
            identificator={selectedDeleteItem.id}
            url={`/orders`}
          />
        )}
        <DebtModal
          message={message}
          isVisible={debtModal}
          onClose={handleCloseDebModal}
          code={distributorToken}
        />
      </div>
    </div>
  );
};

export default PurchaseList;
